import React from "react";

const TIER_STYLE = {
  info: {
    color: "#93C5FD",
    background: "transparent",
    border: "none",
    icon: false,
  },
  caution: {
    color: "#D97706",
    background: "transparent",
    border: "none",
    icon: true,
  },
  blocking: {
    color: "#F87171",
    background: "rgba(239, 68, 68, 0.08)",
    border: "1px solid rgba(248, 113, 113, 0.28)",
    icon: true,
  },
};

function CautionMark() {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" aria-hidden="true" className="shrink-0">
      <path d="M4 0.6 L7.6 7.2 H0.4 Z" fill="currentColor" />
    </svg>
  );
}

export function StatusBadge({
  tier = "info",
  text,
  title,
  onClick,
  expanded = false,
  testid,
}) {
  if (!text) return null;
  const style = TIER_STYLE[tier] || TIER_STYLE.info;
  const clickable = typeof onClick === "function";
  const Tag = clickable ? "button" : "span";
  return (
    <Tag
      type={clickable ? "button" : undefined}
      className="inline-flex items-center gap-1 max-w-[11rem] text-[9px] leading-tight font-medium rounded-sm px-1 py-0.5 text-left"
      style={{
        color: style.color,
        background: style.background,
        border: style.border,
        cursor: clickable ? "pointer" : "help",
      }}
      title={title || text}
      aria-expanded={clickable ? expanded : undefined}
      onClick={clickable ? (ev) => { ev.stopPropagation(); onClick(); } : undefined}
      data-testid={testid}
      data-status-tier={tier}
    >
      {tier === "caution" && style.icon ? <CautionMark /> : null}
      {tier === "blocking" && style.icon ? (
        <span aria-hidden="true" className="text-[8px] font-bold leading-none">!</span>
      ) : null}
      <span className="truncate">{text}</span>
    </Tag>
  );
}

export function statusToneStyle(tier) {
  if (tier === "blocking") {
    return { color: "#F87171", background: "rgba(239, 68, 68, 0.08)", borderColor: "rgba(248, 113, 113, 0.28)" };
  }
  if (tier === "caution") {
    return { color: "#D97706", background: "transparent", borderColor: "var(--hoip-border)" };
  }
  return { color: "var(--hoip-text-secondary)", background: "transparent", borderColor: "var(--hoip-border)" };
}
